import { render } from "./who-was-page.vue?vue&type=template&id=55804e4f"
import script from "./who-was-page.vue?vue&type=script&lang=js"
export * from "./who-was-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__